import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {WidgetModel} from '../../model/widget.model';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {PaymentModalComponent} from '../../../../components/payments/payment-modal/payment-modal.component';
import {FinanceService} from '../../../../services/api/finance.service';
import {filter, map, of, Subscription, switchMap, tap} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {HelpersService} from '../../../../services/helpers.service';
import {MemberService} from '../../../../services/member.service';
import {AlertService} from '../../../../services/notify/alert.service';

@Component({
    selector: 'app-etf-bill-widget',
    templateUrl: './etf-bill-widget.component.html',
    styleUrl: './etf-bill-widget.component.scss',
})
export class AppEtfBillWidgetComponent {
    @Input() widgetData: WidgetModel;
    public ownerName: string
    private subscriptions: Subscription = new Subscription()
    private paymentHistoryRef: MatDialogRef<PaymentModalComponent>

    constructor(
        private dialog: MatDialog,
        private financeService: FinanceService,
        private alertService: AlertService,
        private translate: TranslateService,
        private memberService: MemberService,
        private helper: HelpersService,
        private chageDetectRef: ChangeDetectorRef
    ) {
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe()
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.memberService.getMemberGuid(this.widgetData.content.owner_guid).subscribe(data => {
                this.ownerName = this.helper.fullName(data)
                this.chageDetectRef.detectChanges()
            })
        )
    }

    showPaymentHistory() {
        this.subscriptions.add(
            of(this.widgetData.options_dict.person)
                .pipe(
                    switchMap(person => person ? this.financeService.getAllPrivateWallets() : this.financeService.getFinance().pipe(map(el => el.purse))),
                    map(data => data.wallets.find(el => el.is_master)),
                    switchMap(master => this.financeService.getPaymentsHistory(master?.guid || '')),
                    tap(data => data.payments?.data?.length > 0 ? null : this.alertService.setAlert(this.translate.instant('EMPTY_LISTS.PAYMENT_HISTORY'), 'blue', 5)),
                    filter(data => data.payments?.data?.length > 0))
                .subscribe(data => {
                        this.paymentHistoryRef = this.dialog.open(PaymentModalComponent, {
                            height: '90%',
                            maxHeight: '95%',
                            width: '80%',
                            maxWidth: '95vw'
                        })
                        this.paymentHistoryRef.componentInstance.detail = false;
                        this.paymentHistoryRef.componentInstance.payments = data.payments?.data;
                        this.paymentHistoryRef.componentInstance.walletProjectGuid = data.payments?.data[0]?.guid;
                    }
                ));
    }
}